import React, { useState, useEffect } from "react";
import { HeartHandshake } from "lucide-react";

export default function DonateFAB({ onClick }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      onClick={onClick}
      data-testid="donate-fab"
      aria-label="Donate"
      className={`fixed z-40 bottom-6 left-6 btn-gold shadow-[0_18px_40px_-12px_rgba(212,175,55,0.55)] transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <HeartHandshake className="h-4 w-4" />
      Donate
    </button>
  );
}
